import { useEffect } from "react";
import { useHistory, useLocation } from "react-router";
import { common_utils } from "../../../../common/common_utils";
import { DashboardUtils } from "../dashboard_utils";
import { trpc } from "../utils/trpc";

interface StateObject {
	guild_id: string;
	code_source: "google";
}

export default function GoogleRedirectPage() {
	const location = useLocation();
	const history = useHistory();
	const query = new URLSearchParams(location.search);

	const code = query.get("code");
	const state = query.get("state");

	const setAuthMutation = trpc.gcal.setAuth.useMutation();

	useEffect(() => {
		if (!code || !state) {
			history.push("/dashboard");
			return;
		}

		let stateObj: StateObject;
		try {
			// Decode base64 state and parse JSON
			const decodedState = atob(state);
			stateObj = JSON.parse(decodedState) as StateObject;
		} catch (e) {
			console.error("Failed to parse state:", e);
			history.push("/dashboard");
			return;
		}

		if (stateObj.code_source !== "google") {
			console.error("Invalid code source in state");
			history.push("/dashboard");
			return;
		}

		setAuthMutation.mutateAsync(
			{ code },
			{
				onSettled() {
					history.push(
						common_utils.getGuildSettingsURL(stateObj.guild_id) +
							"?section=sync"
					);
				},
			}
		);
	}, []);

	return <DashboardUtils.RenderFullLoadingThrobberPage />;
}
